import { LOCATION_CHANGE, RouterAction } from "connected-react-router"
import { Reducer } from "redux"
import { WorkerType, AuthUserType } from "../../Actions/Types"
import { updateAt } from "../../Helpers/Functions/reducer"
import { APIAppWorker, getAppWorkerId } from "../../Models/API/AppWorker"
import { APIWorker, getWorkerId } from "../../Models/API/Worker"
import {
    getInitialData,
    markAllPagesOfAllEntriesAsStale,
    RemoteData,
    setItem,
    setPage
} from "../../Models/Client/RemoteData"
import { SortExpression } from "../../Models/Client/SortExpression"
import { AuthAction } from "../Auth"

export interface WorkerState {
    org: {
        [orgUsername: string]:
            | RemoteData<APIWorker, SortExpression<APIWorker>, string>
            | undefined
    }
    app: {
        [appID: string]:
            | RemoteData<APIAppWorker, SortExpression<APIAppWorker>, string>
            | undefined
    }
}

interface WorkerSetWorkerListAction {
    type: WorkerType.setWorkerList
    meta: {
        total: number
        page: number
        orgUsername: string
        sort: SortExpression<APIWorker>
    }
    payload: APIWorker[]
}

interface WorkerSetAppWorkerListAction {
    type: WorkerType.setAppWorkerList
    meta: {
        total: number
        page: number
        appID: string
        sort: SortExpression<APIAppWorker>
    }
    payload: APIAppWorker[]
}

interface WorkerSetAppWorkerAction {
    type: WorkerType.setAppWorker
    payload: APIAppWorker
}

export type WorkerAction =
    | WorkerSetWorkerListAction
    | WorkerSetAppWorkerListAction
    | WorkerSetAppWorkerAction

const initialState: WorkerState = {
    org: {},
    app: {}
}

export const WorkerReducer: Reducer<
    WorkerState,
    WorkerAction | AuthAction | RouterAction
> = (state = initialState, action): WorkerState => {
    switch (action.type) {
        case LOCATION_CHANGE:
            return {
                ...state,
                org: markAllPagesOfAllEntriesAsStale(state.org),
                app: markAllPagesOfAllEntriesAsStale(state.app)
            }
        case WorkerType.setWorkerList:
            return {
                ...state,
                org: {
                    [action.meta.orgUsername]: setPage(
                        state.org[action.meta.orgUsername] ?? getInitialData(),
                        action.meta.sort,
                        action.payload,
                        getWorkerId,
                        action.meta.page,
                        action.meta.total
                    )
                }
            }
        case WorkerType.setAppWorkerList:
            return {
                ...state,
                app: {
                    [action.meta.appID]: setPage(
                        state.app[action.meta.appID] ?? getInitialData(),
                        action.meta.sort,
                        action.payload,
                        getAppWorkerId,
                        action.meta.page,
                        action.meta.total
                    )
                }
            }
        case WorkerType.setAppWorker:
            return {
                ...state,
                app: updateAt(state.app, action.payload.appUuid, table =>
                    setItem(
                        table ?? getInitialData(),
                        String(action.payload.worker.id),
                        action.payload,
                        getAppWorkerId
                    )
                )
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
